export default "__VITE_ASSET__efd1d194__"